import _implicitStylesheets from "./exploreBucket.css";
import _implicitScopedStylesheets from "./exploreBucket.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="bucket-text${0}"${2}>${"t1"}</span>`;
const stc0 = {
  "type": "button"
};
const stc1 = {
  "bucket": true
};
const stc2 = {
  "bucket-image": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("button", {
    classMap: stc1,
    attrs: {
      "data-selected": $cmp.selected
    },
    key: 1,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleBucketClick))
    }
  }, [api_custom_element("ads-icon", _adsIcon, {
    classMap: stc2,
    props: {
      "symbol": $cmp.icon,
      "size": "large"
    },
    key: 2
  }), api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.label))])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-38ds51smnm4";
tmpl.legacyStylesheetToken = "undefined-_exploreBucket";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
